// Hidden Safari tabs may suspend requestAnimationFrame entirely. Layout still
// needs to establish the usable canvas, so a bounded timer races the queued
// frame. This is only for measurements, never the demonstration/media clock.
export function createFrameScheduler(measure,{
 request=callback=>requestAnimationFrame(callback),
 cancel=handle=>cancelAnimationFrame(handle),
 setTimer=(callback,delay)=>setTimeout(callback,delay),
 clearTimer=handle=>clearTimeout(handle),
 fallbackMs=100,
}={}) {
 let pending=null,disposed=false;
 const clear=work=>{
  if(work.frame!==null)cancel(work.frame);
  if(work.timer!==null)clearTimer(work.timer);
 };
 const scheduler={
  schedule(){
   if(disposed||pending!==null)return;
   const work={frame:null,timer:null};pending=work;
   const run=()=>{
    if(pending!==work)return;
    pending=null;clear(work);
    if(!disposed)measure();
   };
   work.frame=request(run);
   if(pending===work)work.timer=setTimer(run,fallbackMs);
  },
  cancel(){if(pending!==null){const work=pending;pending=null;clear(work);}},
  dispose(){disposed=true;scheduler.cancel();},
 };
 return scheduler;
}
